<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img mt-5">
            <div class="col-md-6 m-auto mt-5">
                <div class="card">
                    <div class="card-header small text-white pt-0 pb-0" :style="{ backgroundColor: moduloAtual().color }">
                        Baixa Recebimento
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1">

                      <div class="small p-0 m-0">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite a chave da nota fiscal"
                            titleScan="Escanear Nota Fiscal"
                            typeInputMode="numeric"
                            @displayScanFunction="baixaRecebimento"
                            :enterKey="(e) => baixaRecebimento(e.target.value, 1)"
                            idInput="codigoBarrasInput"
                            :errorMessage="this.error"
                        >
                        </InputDefaultApp>
                      </div>
                    </div>
                </div>
                <div class="card mt-2 mt-0" v-if="this.retorno.itens">
                    <div class="card-header p-0 small">
                        <code class="text-danger small bg-light" v-if="this.retorno.iddocumentos">
                            {{ this.retorno.fantasia + " - " +  this.retorno.clientes_idclientes }}
                        </code>
                    </div>
                    <div class="card-body p-1">
                        <div class="alert alert-warning small pt-1 pb-1 mb-1" v-if="!this.retorno.iddocumentos">
                            NOTA NÃO INTEGRADA NO SISTEMA
                        </div>

                        <div class="small text-left pl-1">
                            

                            <div v-if="this.retorno.statuslib">
                                <code class="small bg-light text-dark font-weight-bold">STATUS:</code>
                                <span class="small text-danger">
                                    {{ this.retorno.statuslib }}
                                </span>
                            </div>

                            <div v-if="this.retorno.iddocumentos">
                                <code class="small bg-light text-dark font-weight-bold">NF:</code>
                                <span class="text-danger small" v-if="this.retorno.numeronf">
                                    {{ this.retorno.numeronf }}
                                </span>

                                <code class="small bg-light ml-3 text-dark font-weight-bold">SÉRIE:</code>
                                <span class="text-danger small" v-if="this.retorno.serie">
                                    {{ this.retorno.serie }}
                                </span>

                                <code class="small bg-light ml-3 text-dark font-weight-bold">ID:</code>
                                <span class="text-danger small" v-if="this.retorno.iddocumentos">
                                    {{ this.retorno.iddocumentos }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mt-2" v-if="this.retorno.itens">
                    <div class="card-body p-1 small">
                        <div style="overflow-y: auto; overflow-x: hidden; height: 180px;">
                            <div class="border mb-1 rounded pt-1 small text-left" v-for="(item) of this.retorno.itens" :key="item.idprodutos">
                            
                                <ul class="nav nav-tabs small" :id="'myTab_'+item.idprodutos">
                                    <li class="nav-item">
                                        <a class="nav-link active" :id="'tab1-tab_'+item.idprodutos" data-toggle="tab" :href="'#tab1_'+item.idprodutos" role="tab">PRODUTO</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" :id="'tab2-tab_'+item.idprodutos" data-toggle="tab" :href="'#tab2_'+item.idprodutos" role="tab">ENDERECOS</a>
                                    </li>
                                </ul>
                                <div :class="['tab-content', 'mt-0', item.class]" :id="'myTabContent_'+item.idprodutos">
                                    <div class="tab-pane fade show active p-2 small" :id="'tab1_'+item.idprodutos" role="tabpanel">
                                        <span class="text-danger font-weight-bold">{{ item.descricao }}</span>
                                        <div class="border-bottom mb-2"></div>
                                        <span class="font-weight-bold">Produto:</span>
                                        [<span class="text-danger font-weight-bold">{{ item.codbarras }}</span>]
                                        <span class="font-weight-bold ml-3">Qtde Nota:</span>
                                        [<span class="text-danger font-weight-bold">{{ item.qtde }}</span>]
                                        <br>
                                        <span class="font-weight-bold">SKU:</span>
                                        [<span class="text-danger font-weight-bold">{{ item.sku }}</span>]
                                        <br>
                                        <span class="font-weight-bold">1º CONFERÊNCIA:</span>
                                        <span class="text-danger font-weight-bold ml-2">{{ item.qtdeconf1 }}</span>
                                        <br>
                                        <span class="font-weight-bold">2º CONFERÊNCIA:</span>
                                        <span class="text-danger font-weight-bold ml-2">{{ item.qtdeconf2 }}</span>
                                        <br>
                                        <span class="font-weight-bold">LOTE / VALIDADE:</span>
                                        <span v-if="item.lote" class="font-weight-bold ml-2">
                                            [<span class="text-danger">{{ item.lote }}</span>] - [<span class="text-danger">{{ dateFormat(item.validade) }}</span>]
                                        </span>
                                    </div>
                                    <div class="tab-pane fade show p-1" :id="'tab2_'+item.idprodutos" role="tabpanel">
                                        <table class="table table-striped table-bordered">
                                            <caption class="d-none"></caption>
                                            <thead>
                                                <tr>
                                                    <th>POSIÇÃO</th>
                                                    <th>QTDE</th>
                                                    <th>NOTA</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="item.enderecos">
                                                <tr v-for="(endereco) of item.enderecos" :key="endereco.idrecebimento_has_produto">
                                                    <td>{{ endereco.descricao }}</td>
                                                    <td>{{ endereco.qtd_entrada }}</td>
                                                    <td>{{ endereco.documentos_iddocumentos }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 mb-5 text-center text-secondary" v-if="!this.retorno.itens">
                  <em class="fa fa-info-circle fa-3x mb-2"></em>
                  <br>
                  <span class="small">Bipe a chave da nota fiscal!</span>
                </div>

                <button id="btnBaixarRecebimento" class="btn btn-primary btn-sm w-100 mt-1" v-if="this.retorno.iddocumentos" @click="dialogoBaixarRecebimento()">
                    Baixar Recebimento
                    <em class="fa fa-download ml-2"></em>
                </button>
            </div>
        </div>

        <Modal
            id="modalDialogoBaixarRecebimento"
            title="Confirme:"
            confirmText="Sim"
            cancelText="Não"
            :confirmFunction="baixarRecebimento"
            :cancelFunction="closeModal('modalDialogoBaixarRecebimento')"
        >
            Deseja baixar nota fiscal?
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>

        <Modal
            id="modalError"
            title="Aviso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalError')"
            cancelText="OK"
            :customClass="this.classModal"
        >
            <div class="small text-center">
                <em class="fa fa-info-circle text-warning fa-3x"></em>
                <br>
                <br>
                <span>{{ this.errorMessageModal }}</span>
            </div>
        </Modal>

        <LogoutModal />
    </div>
</template>
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUsername, getPerfil, getUserId } from '../services/api'
    import InputDefaultApp from "../components/InputDefaultApp.vue";
    import $ from "jquery";
    import audioService from '@/services/audioService.js';
    import { dateFormat } from '../utils';
    import Modal from "../components/Modal.vue";

    export default {
        name: 'BaixaRecebimento',
        mixins: [
            ViewMixin
        ],
        components: {
            Topbar,
            LogoutModal,
            InputDefaultApp,
            Modal,
        },
    
        data: () => {
            return {
                chaveReferencia: null,
                error: null,
                retorno: {
                    itens: null
                },
                retornoMessage: null,
                errorMessageModal: null,
                classModal: null,
            };
        },
    
        async mounted() {
            try {
                await this.validarToken();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }      
            }

            this.focusInput();
        },
    
        methods: {
            getUsername,
            getPerfil,
            getUserId,
            dateFormat,

            closeModal(modal) {
                $("#" + modal).modal("hide");
            },

            playSoundWarning() {
                audioService.ops();
            },

            playSoundSuccess() {
                audioService.success();
            },

            showMessageSuccess(message) {
                this.retornoMessage = message;
                $("#modalRetorno").modal('show');
            },

            showErrorModal(message) {
                this.errorMessageModal = message;
                $("#modalError").modal('show');
            },

            async validarToken() {
                this.carregando = true;
        
                await api.get("/validar-token");
        
                this.carregando = false;
            },

            focusInput() {
                setTimeout(() => {
                    $("#codigoBarrasInput").focus();
                    $("#codigoBarrasInput").select();
                }, 250)
            },

            async baixaRecebimento(chave) {

                if (chave.length !== 44) {
                    this.error = "A chave precisa ter 44 caracteres!";
                    this.playSoundWarning();
                    this.focusInput();
                    return;
                }

                this.chaveReferencia = chave;
                this.error = null;

                this.carregando = true;

                try {
                    let response = await api.post("/inbound/baixarecebimento/consulta", {
                        chave: chave
                    });

                    this.retorno = response.data;

                    if (this.retorno.statuslib !== "EM CONFERENCIA (2ª ETAPA)") {
                        setTimeout(() => {
                            $("#btnBaixarRecebimento").prop("disabled", true);
                        }, 250);
                    }

                    if (this.retorno.statuslib === "NOTA NÃO INTEGRADA") {
                        this.playSoundWarning();
                    } else {
                        this.playSoundSuccess();

                        for (let item of this.retorno.itens) {
                            if (item.qtdeconf1 !== item.qtdeconf2) {
                                item["class"] = "divergente";
                            } else {
                                item["class"] = "bg-white";
                            }
                        }
                    }
                    
                    this.focusInput();
                } catch (error) {
                    this.error = error.message;
                    this.focusInput();
                    this.playSoundWarning();
                }

                this.carregando = false;
            },

            dialogoBaixarRecebimento() {
                $("#modalDialogoBaixarRecebimento").modal("show");
            },

            async baixarRecebimento() {
                $("#modalDialogoBaixarRecebimento").modal("hide");
                this.carregando = true;

                this.error = null;

                try {
                    let response = await api.post('/inbound/baixarrecebimento', {
                       chaveNfe: this.chaveReferencia,
                       idUsuario: getUserId()
                    });

                    this.showMessageSuccess(response.data);
                    this.baixaRecebimento(this.chaveReferencia);
                } catch (error) {
                    this.showErrorModal(error.message);
                    this.playSoundWarning();
                }

                this.carregando = false;
            },
        }
    }
</script>
  
<style scoped lang="scss">    
  
    .home-view {
        height: 100%;
    }

    .btn-detalhes 
    {
        display: inline;
        position: relative;
        top: -15px;
        left: 60px;
    }

    .divergente {
        background-color: rgb(255, 250, 182);
    }
</style>
  